import { __ } from '@wordpress/i18n';
import { useEffect, useState } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';
import {BlockControls} from '@wordpress/block-editor';
import PanelSettings from './advance/inspector-control';
import AdvanceSettings from './advance';
import { Spinner } from '@wordpress/components';
import { VayuBlocksDevice } from '@vayu-blocks/device-control';
import {CopyPasteStyles} from '@vayu-blocks';
import { VideoHtml, MouseFollower } from '@vayu-blocks';
import { VayuBlocksUniqueId} from '@vayu-blocks/global';

import {
    gridContainerStyles,
    postStyles,
    featuredImageStyles,
    categoryButtonStyles,
    titleTagStyles,
    authorLinkStyles,
    tagButtonStyles,
    authorAndDateContainerStyles,
    showOnlyDateStyles,
    fullContentStyle,
    PaginationStyles,
    dateSectionStyles,
    titleTagStylesatag,
    paginationnewstyle,
    categoryContainerStyles,
    tagContainerStyles,
    excerptstyles,
} from './edit-style';

const Edit = ({ attributes, setAttributes,clientId,isSelected }) => {

    const [filteredPosts, setFilteredPosts] = useState([]);
    const [totalPages, setTotalPages] = useState(1); 
    const [CurrentPage, setCurrentPage] = useState(1);
    const [filter, setFilter] = useState({ featuredImage: false, categories: []});
    const [Loading, setLoading] = useState(false);

    VayuBlocksUniqueId({ 
		setAttributes: setAttributes, 
		clientId: clientId
	});

    //TitleTag Define
    const TitleTag = attributes.pg_blockTitleTag || 'h2';

    const gridContainerStyle = gridContainerStyles(attributes);
    
    const featuredImageStyle = featuredImageStyles(attributes);

    const categoryButtonStyle = categoryButtonStyles(attributes);

    const tagContainerStyle = tagContainerStyles(attributes);

    const categoryContainerStyle = categoryContainerStyles(attributes);

    const titleTagStyle = titleTagStyles(attributes);

    const authorLinkStyle = authorLinkStyles(attributes);

    const tagButtonStyle = tagButtonStyles(attributes);

    const postStyle = postStyles(attributes);

    const authorAndDateContainerStyle = authorAndDateContainerStyles(attributes);

    const PaginationStyle = PaginationStyles(attributes);
    
    const showOnlyDateStyle = showOnlyDateStyles(attributes);

    const fullContentStyles = fullContentStyle(attributes);

    const excerptstyle = excerptstyles(attributes);
    
    const titleTagStylesatagq = titleTagStylesatag(attributes);

    const paginationnew = paginationnewstyle(attributes);

    const getView = VayuBlocksDevice();
    
    const numberOfRow= () => attributes.column?.[getView] ?? 3;
    const numberOfColumns= () => attributes.row?.[getView] ?? 2;
    
    //load ppost
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                // Construct the filter query parameters
                const queryParams = [];
    
                if (filter.featuredImage) {
                    queryParams.push('with_featured_image=true');
                }
                if (filter.categories.length > 0) {
                    const categoryIds = filter.categories.join(',');
                    queryParams.push(`categories=${categoryIds}`);
                }
    
                const per_page= numberOfColumns() * numberOfRow();
                // Build the final API path with filters
                const queryString = queryParams.length ? `&${queryParams.join('&')}` : '';

                const apiPath = `/wp/v2/posts?page=${CurrentPage}&per_page=${per_page}&_embed&order=${attributes.sortByOrder}&orderby=${attributes.sortByField}${queryString}`;
                const response = await apiFetch({
                    path: apiPath,
                    parse: false
                  });

                // Log results
                const fetchedPosts = await response.json();
                const pages = await response.headers.get('X-WP-TotalPages');
                const postsWithIDs = fetchedPosts.map(post => ({ ...post, uniqueID: generateUniqueID() }));
                setAttributes({pg_posts:postsWithIDs})
                setFilteredPosts(postsWithIDs);
                setTotalPages(pages);

            } catch (error) {
                console.error('Error fetching data:', error);
            }finally{
                setLoading(false);
            }
        };
        fetchData();
    }, [filter, attributes.sortByOrder, attributes.sortByField,numberOfColumns(),numberOfRow(),attributes.selectedCategories,
        attributes.pg_featuredImageOnly,CurrentPage]);
    
    useEffect(() => {
        const fetchCategoriesAndUpdateFilter = async () => {
            try {
                // Fetch categories to get IDs
                const fetchedCategories = await apiFetch({ path: '/wp/v2/categories' });
                // Create a mapping of category names to IDs
                setAttributes({pg_allCategories:fetchedCategories});
                const categoryNameToIdMap = fetchedCategories.reduce((acc, category) => {
                    acc[category.name] = category.id;
                    return acc;
                }, {});
    
                // Map selected category names to their IDs
                const categoryIds = attributes.selectedCategories.map(categoryName => 
                    categoryNameToIdMap[categoryName] || null
                ).filter(id => id !== null);

                // Update filter state with IDs and other parameters
                setFilter(prevFilter => ({
                    ...prevFilter,
                    featuredImage: attributes.pg_featuredImageOnly,
                    categories: categoryIds,
                }));
    
            } catch (error) {
                console.error('Error fetching categories or updating filter:', error);
            }
        };
    
        fetchCategoriesAndUpdateFilter();
    }, [attributes.pg_featuredImageOnly, attributes.selectedCategories]);
    
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    
    const limitExcerpt = (content, words) => {
        const text = content.replace(/<\/?[^>]+(>|$)/g, ""); // Strip HTML tags
        const wordsArray = text.split(" ");
        return wordsArray.slice(0, words).join(" ") ;
    };

    function generateUniqueID() {
        return clientId;
    }
    
    const parseHTML = (html) => {
        const element = document.createElement('div');
        element.innerHTML = html;
        return Array.from(element.childNodes).map((node, index) => {
            switch (node.nodeName) {
                case '#text':
                    return node.nodeValue;
                case 'P':
                    return <p key={index}>{parseHTML(node.innerHTML)}</p>;
                case 'STRONG':
                    return <strong key={index}>{parseHTML(node.innerHTML)}</strong>;
                // Add cases for other HTML tags as needed
                default:
                    return <span key={index}>{parseHTML(node.innerHTML)}</span>;
            }
        });
    };

    const FeaturedImage = attributes.featuredImage?.[getView] ?? false;

    const Category = attributes.categori?.[getView] ?? false;

    const Author = attributes.auth?.[getView] ?? false;

    const ShowDate = attributes.date?.[getView] ?? false;

    const Tags = attributes.Showtag?.[getView] ?? false;

    const Excerpt= attributes.expertview?.[getView] ?? false;

    const ExcerptWords= () => getView === 'Desktop' ? attributes.pg_excerptWords : getView === 'Tablet' ? attributes.pg_excerptWordsTablet : attributes.pg_excerptWordsMobile;

    const FullContent = attributes.fullContent?.[getView] ?? false;

    const postsToShow = filteredPosts.length > 0 ? filteredPosts : attributes.pg_posts;

    return (
        <>

            <BlockControls>
                <CopyPasteStyles attributes={attributes} setAttributes={setAttributes} blockName={'vayu-blocks/post-grid'}/>
            </BlockControls>
            <PanelSettings
                attributes={attributes}
                setAttributes={setAttributes}
                isSelected={isSelected}
                clientId={clientId}
            />

            <AdvanceSettings attributes={attributes} clientId={clientId}>
            
                {filteredPosts && filteredPosts.length > 0 ? (
                    <div style={gridContainerStyle}>
                    {postsToShow.length > 0 ? (
                        postsToShow.map((post) => (
                            
                            <div key={post.uniqueID} style={postStyle} >
                                {Loading ? (
                                    <div className="loader">
                                        <Spinner/>
                                        <h6 style={{fontSize:'15px'}}>Please Wait...</h6>
                                        {/* This is the animated loader div */}
                                    </div>
                                   
                                ) : (
                                    <>
                                        {FeaturedImage && post._embedded && post._embedded['wp:featuredmedia'] && post._embedded['wp:featuredmedia'].length > 0 && (
                                            <div style={{overflow:'hidden'}}>
                                                <img
                                                    src={post._embedded['wp:featuredmedia'][0].source_url}
                                                    alt={post._embedded['wp:featuredmedia'][0].alt_text}
                                                    style={featuredImageStyle}
                                                    className={attributes.pg_featuredimage_animate ? "animatefeaturedimage" : ""}
                                                />
                                            </div>
                                        )}
                
                                        {Category && (
                                           <div style={categoryContainerStyle}>
                                         
                                                {post._embedded['wp:term'][0].slice(0, attributes.pg_numberOfCategories).map((category) => (
                                                    <a key={category.id} href={category.link} style={categoryButtonStyle}>
                                                        {category.name}
                                                    </a>
                                                ))}
                                            </div>
                                        )}
                
                                        <TitleTag className="titletag" style={titleTagStyle}>
                                            <a href={post.link} style={titleTagStylesatagq} 
                                                onMouseEnter={(e) => {
                                                    e.target.style.color = 'transparent';
                                                    e.target.style.background = `${attributes.pg_TitleColorhvr}`; 
                                                    e.target.style.backgroundClip = 'text'; 
                                                    e.target.style.WebkitBackgroundClip = 'text';
                                                    e.target.style.WebkitTextFillColor = 'transparent';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.color = `${attributes.pg_TitleColor}`; 
                                                    e.target.style.background = 'initial'; 
                                                    e.target.style.backgroundClip = 'initial'; 
                                                    e.target.style.WebkitBackgroundClip = 'initial';
                                                    e.target.style.WebkitTextFillColor = 'initial'; 
                                                }}
                                            >
                                                {post.title.rendered}
                                            </a>
                                        </TitleTag>
                
                                        {(Author || ShowDate) && (
                                            <div style={authorAndDateContainerStyle}>

                                                {Author && (
                                                    <div style={dateSectionStyles}>

                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" aria-hidden="true" focusable="false"><path fill-rule="evenodd" d="M7.25 16.437a6.5 6.5 0 1 1 9.5 0V16A2.75 2.75 0 0 0 14 13.25h-4A2.75 2.75 0 0 0 7.25 16v.437Zm1.5 1.193a6.47 6.47 0 0 0 3.25.87 6.47 6.47 0 0 0 3.25-.87V16c0-.69-.56-1.25-1.25-1.25h-4c-.69 0-1.25.56-1.25 1.25v1.63ZM4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm10-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" clip-rule="evenodd"></path></svg>
                                                        <a
                                                            href={post._embedded['author'][0].link}
                                                            style={authorLinkStyle}
                                                        >
                                                            By {post._embedded['author'][0].name}
                                                        </a>
                                                    </div>
                                                )}
                
                                                {ShowDate && (
                                                    <div style={dateSectionStyles}>

                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" aria-hidden="true" focusable="false"><path d="M11.696 13.972c.356-.546.599-.958.728-1.235a1.79 1.79 0 00.203-.783c0-.264-.077-.47-.23-.618-.148-.153-.354-.23-.618-.23-.295 0-.569.07-.82.212a3.413 3.413 0 00-.738.571l-.147-1.188c.289-.234.59-.41.903-.526.313-.117.66-.175 1.041-.175.375 0 .695.08.959.24.264.153.46.362.59.626.135.265.203.556.203.876 0 .362-.08.734-.24 1.115-.154.381-.427.87-.82 1.466l-.756 1.152H14v1.106h-4l1.696-2.609z"></path><path d="M19.5 7h-15v12a.5.5 0 00.5.5h14a.5.5 0 00.5-.5V7zM3 7V5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V7z"></path></svg>

                                                        <span style={showOnlyDateStyle}>
                                                            {new Date(post.date).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric' })}
                                                        </span>
                                                        </div>
                                                )}
                                            </div>
                                        )}
                
                                        {Excerpt && (
                                            <div style={fullContentStyles}>
                                                {limitExcerpt(post.excerpt.rendered, ExcerptWords())} {' '}
                                                <span style={excerptstyle} className="vb-excerpt-selected">{attributes.pg_excerptSelector}</span>
                                            </div>
                                        )}
                
                                        {FullContent && (
                                            <div style={fullContentStyles}>
                                                {parseHTML(post.content.rendered)}
                                            </div>
                                        )}
                
                                        {Tags && (
                                            <div style={tagContainerStyle}>
                                                {post._embedded['wp:term'][1].slice(0, attributes.pg_numberOfTags).map((tag) => (
                                                    <a key={tag.id} href={tag.link} style={tagButtonStyle}>
                                                        {tag.name}
                                                    </a>
                                                ))}
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                            
                        ))
                    ) : (
                        <p>{__('No post to display', 'pg-block')}</p>
                    )}
                </div>
                
               
                ) : (
                    <div style={{display:'flex',flexDirection:'column', alignItems:'center'}}>
                        <p>{__('Loading...', 'pg-block')}</p>
                        <Spinner />
                    </div>
                )}

                {/* Pagination */}
                {attributes.showpagination && totalPages > 1 && (
                    <div className="pg-pagination" style={paginationnew}>
                        {CurrentPage > 1 && (
                            <button
                                style={{...PaginationStyle,
                                color:attributes.pg_PaginationColor}}
                                onClick={() => handlePageChange(CurrentPage - 1)}
                                className="pg-pagination-button"
                            >
                                &laquo;
                            </button>
                        )}

                        {Array.from({ length: totalPages }, (_, index) => {
                            const page = index + 1;
                            const isCurrentPage = page === CurrentPage;
                            const isFirstPages = page <= 2; // Always show first 2 pages
                            const isLastPages = page >= totalPages - 1; // Always show last 2 pages
                            const isNearbyCurrentPage = Math.abs(page - CurrentPage) <= 1; // Show pages next to current page

                            if (isFirstPages || isLastPages || isNearbyCurrentPage) {
                                return (
                                    <button
                                        style={{
                                            ...PaginationStyle,
                                            color: isCurrentPage ? `${attributes.pg_PaginationactiveColor}` : `${attributes.pg_PaginationColor}`,
                                        }}
                                        key={index}
                                        onClick={() => handlePageChange(page)}
                                        className={`pg-pagination-button ${isCurrentPage ? 'active' : ''}`}
                                    >
                                        {page}
                                    </button>
                                );
                            } else if (page === 3 && CurrentPage > 4) {
                                return <span key={index} className="pg-pagination-separator">...</span>;
                            } else if (page === totalPages - 2 && CurrentPage < totalPages - 3) {
                                return <span key={index} className="pg-pagination-separator">...</span>;
                            } else {
                                return null;
                            }
                        })}

                        {CurrentPage < totalPages && (
                            <button
                                style={{...PaginationStyle,
                                color:attributes.pg_PaginationColor}}
                                onClick={() => handlePageChange(CurrentPage + 1)}
                                className="pg-pagination-button"
                            >
                                &raquo;
                            </button>
                        )}
                    </div>
                )}
                
                <MouseFollower value={attributes.advFollower} clientId={clientId}/>
            </AdvanceSettings>
        </>
    );
    
		
};
	
export default Edit;